var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"popover",staticClass:"v-popover"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"contentWrapper",staticClass:"v-popover-content",class:[
            ("v-popover-placement-common-" + (_vm.placement.split('-')[0])),
            ("v-popover-placement-" + _vm.placement),
            _vm.popperClass
         ],style:({ width: _vm.width })},[_vm._t("content",null,{"close":_vm.close})],2),_c('div',{ref:"triggerWrapper",staticClass:"trigger"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }